<div
  class="sidebar"
  (mouseenter)="onPointerEnter()"
  (mouseleave)="onPointerLeave()"
  (focusin)="onFocusIn($event)"
  (focusout)="onFocusOut()"
  [class.sidebar--collapsed]="!isSidebarOpen"
>
  <div class="sidebar__menu">
    @if (isSidebarOpen) {
      <app-search-bar
        class="sidebar__search"
        iconUrl="public/icons/common/search-icon.svg"
        [placeholder]="'SIDEBAR.SEARCH_PLACEHOLDER' | transloco"
        (searchValueEvent)="onMenuSearch($event)"
        (cleanSearchEvent)="onMenuSearchClear()"
      />
    } @else {
      <!-- Colapsado el buscador no cabe, pero su lugar se reserva con la lupa:
           sin ella, al desplegar aparecía una opción nueva arriba y corría el
           resto de ítems, lo que confundía al usuario. -->
      <button
        type="button"
        class="sidebar__search-toggle"
        [attr.aria-label]="'SIDEBAR.SEARCH_PLACEHOLDER' | transloco"
        (click)="onSearchToggleClick()"
      >
        <img src="public/icons/common/search-icon.svg" alt="" />
      </button>
    }

    <!-- Inicio (home) -->
    <app-sidebar-item
      key="dashboard"
      [title]="'SIDEBAR.HOME' | transloco"
      iconUrl="public/icons/common/home-icon.svg"
      [activeSignal]="activeItem"
      [route]="routes.DASHBOARD"
    />

    <!-- Proveedores -->
    @if (isProveedorProducto()) {
      <app-sidebar-item
        key="despachos"
        [title]="'SIDEBAR.DESPACHOS' | transloco"
        iconUrl="public/icons/common/shipping-icon.svg"
        [activeSignal]="activeItem"
        [route]="routes.PROVEEDORES.DESPACHOS"
      />
      <app-sidebar-item
        key="ordenes-compra"
        [title]="'SIDEBAR.PURCHASE_ORDERS' | transloco"
        iconUrl="public/icons/common/order-icon.svg"
        [activeSignal]="activeItem"
        [route]="routes.PROVEEDORES.ORDENES_COMPRA"
      />
    }
    @if (!isProveedorProducto()) {
      <app-sidebar-item
        key="importaciones"
        [title]="'SIDEBAR.IMPORTATIONS' | transloco"
        iconUrl="public/icons/common/import-icon.svg"
        [activeSignal]="activeItem"
        [route]="routes.PROVEEDORES.IMPORTACIONES"
      />
      <app-sidebar-item
        key="tarifas"
        [title]="'SIDEBAR.TARIFAS' | transloco"
        iconUrl="public/icons/common/bill-icon.svg"
        [activeSignal]="activeItem"
        [route]="routes.TARIFAS.SOLICITUDES"
      />
      <!-- Carga masiva de terceros: el RoleGuard ya la bloquea para
           PROVEEDOR_PRODUCTO, por eso tampoco se muestra. -->
      <app-sidebar-item
        key="carga-masiva-terceros"
        [title]="'SIDEBAR.CARGA_MASIVA_TERCEROS' | transloco"
        iconUrl="public/icons/common/uploaded-file-icon.svg"
        [activeSignal]="activeItem"
        [route]="routes.HERRAMIENTAS.CARGA_MASIVA_TERCEROS"
      />
    }
  </div>
</div>
